<template>
  <div class="lesson-content">
    <h1>CI/CD Pipeline Integration</h1>
    <p>Learn how to integrate CodeWatchShip with your CI/CD pipelines for automated monitoring and deployment.</p>

    <h2>GitHub Actions Integration</h2>
    <p>Create a GitHub Actions workflow file at <code>.github/workflows/codewatch.yml</code>:</p>
    <pre><code>name: CodeWatchShip Monitor

on:
  push:
    branches: [ main ]
  pull_request:
    branches: [ main ]

jobs:
  monitor:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v2
      - name: Setup CodeWatchShip
        uses: codeshipwatch/setup-action@v1
      - name: Run Monitoring
        env:
          WATCH_TOKEN: '$&#123;&#123; secrets.WATCH_TOKEN &#125;&#125;'
        run: |
          codewatch monitor --ci</code></pre>

    <h2>Jenkins Pipeline Integration</h2>
    <p>Add CodeWatchShip to your Jenkinsfile:</p>
    <pre><code>pipeline {
  agent any
  stages {
    stage('Monitor') {
      steps {
        sh 'npm install -g @codeshipwatch/cli'
        sh 'codewatch monitor --ci'
      }
    }
  }
}</code></pre>

    <h2>GitLab CI Integration</h2>
    <p>Configure CodeWatchShip in <code>.gitlab-ci.yml</code>:</p>
    <pre><code>monitor:
  stage: monitor
  script:
    - npm install -g @codeshipwatch/cli
    - codewatch monitor --ci
  only:
    - main
    - merge_requests</code></pre>

    <h2>CI Environment Variables</h2>
    <ul>
      <li><strong>WATCH_TOKEN</strong>: Authentication token</li>
      <li><strong>WATCH_CI_MODE</strong>: Enable CI-specific features</li>
      <li><strong>WATCH_FAIL_ON_ERROR</strong>: Fail CI on monitoring errors</li>
    </ul>

    <h2>Summary</h2>
    <p>You now know how to integrate CodeWatchShip with various CI/CD platforms. This completes our tutorial series!</p>
  </div>
</template>

<script>
export default {
  name: 'Chapter2Lesson2'
}
</script>

<style scoped>
.lesson-content {
  color: var(--text);
  line-height: 1.6;
}

h1 {
  color: var(--primary);
  font-size: 2rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

h2 {
  color: var(--text);
  font-size: 1.5rem;
  margin: 2rem 0 1rem;
  font-weight: 600;
}

p {
  margin-bottom: 1rem;
}

ul, ol {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

li {
  margin-bottom: 0.5rem;
}

pre {
  background: #f8fafc;
  border-radius: 6px;
  padding: 1rem;
  margin: 1rem 0;
  overflow-x: auto;
  border: 1px solid var(--border);
}

code {
  font-family: 'Fira Code', 'Consolas', monospace;
  font-size: 0.9rem;
}

p code {
  background: #f8fafc;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

strong {
  font-weight: 600;
}
</style> 